import API from "../../../../app/api";
// Initiate Razorpay Payment
export const initiatePayment = async (ref, payload) => {
  try {
    const response = await API.post(`/checkout/payments/initiate/${ref}`, payload);
    return response;
  } catch (error) {
    console.error("Error initiating payment:", error.response?.data || error);
    return error.response?.data;
  }
};

// Verify Payment via Callback
export const verifyPayment = async (paymentId, orderId, signature) => {
  try {
    const response = await API.get(
      `/checkout/payments/callback?payment_id=${paymentId}&order_id=${orderId}&signature=${signature}`
    );
    return response.data;
  } catch (error) {
    console.error("Error verifying payment:", error.response?.data || error);
    throw error;
  }
};


/**
 * =========================
 * Fetch Placed Order
 * =========================
 */
export const fetchPlacedOrder = async (
    refId
) => {
    try {

        const response = await API.get(
            `/checkout/${refId}/order-placed`
        );

        return response.data;

    } catch (error) {

        console.error(
            "Error fetching placed order:",
            error.response?.data || error
        );

        throw (
            error.response?.data || {
                success: false,
                message: "Failed to fetch order",
            }
        );
    }
};










